import React from "react"

export function BusinessProgressBar(props){
  let page = props.pageIndex 
  return (
    <React.Fragment>
      <div className="col-12 mb-3">
        <div className="progBar col-12 mb-3">
          <div className="element col-3">BUSINESS INFORMATION</div>
          <div className="element col-3">NATURE OF BUSINESS</div>
          <div className="element col-3">STATUTORY INFORMATION</div>
          <div className="element col-3">SUBSCRIPTION DETAILS</div>
        </div>
        <progress className="progressBar" max="4" value={page} />
      </div>
    </React.Fragment>
  )

}